module.exports = {"422827100":"翔凤镇","422827101":"百福司镇","422827102":"大河镇","422827103":"绿水镇","422827104":"旧司镇","422827105":"革勒车镇","422827200":"漫水乡","422827202":"三胡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422827.json
// module id = 1922
// module chunks = 0